import { Theme } from '@cambridgeassessment/cambridge-ui';
import { OrgAssociateStatus } from 'src/types';

export const getColor = (theme: Theme, status: OrgAssociateStatus): string => {
  if (status === OrgAssociateStatus.Approved) {
    return theme.palette.success.main;
  }
  if (status === OrgAssociateStatus.Active) {
    return theme.palette.success.main;
  }
  if (status === OrgAssociateStatus.Inactive) {
    return theme.palette.error.main;
  }
  return theme.palette.neutral.dark;
};
